import { render, staticRenderFns } from "./BccMailManager.vue?vue&type=template&id=aee0a2f2&scoped=true&"
import script from "./BccMailManager.vue?vue&type=script&lang=js&"
export * from "./BccMailManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee0a2f2",
  null
  
)

export default component.exports